// @flow
import React, { useMemo } from 'react';
import evolve from 'ramda/es/evolve';
import values from 'ramda/es/values';
import { useTranslation } from 'react-i18next';

import { AvailableInformersView } from 'app/components/Tariff/AvailableInformers';

import informsDefault from './informsDefault';
import styles from './Tariff.scss';


type Props = {
  service: string,
}

const FreeTariff = ({ service }: Props) => {
  const { t } = useTranslation('tariff');
  const freeInformsDefault = useMemo(() => values(evolve({
    sms: informerParams => ({ ...informerParams, checked: false }),
    email: informerParams => ({ ...informerParams, checked: false }),
  }, informsDefault())), []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.title}>
          <div>{t('free_tariff_title1')}</div>
          <div>{t('free_tariff_title2')}</div>
        </div>
        <div className={styles.info}>
          {t(`free_tariff_${service}_info`)}
        </div>
      </div>

      <div className={styles.line} />

      <div className={styles.content}>
        <div className={styles.row}>
          <AvailableInformersView informs={freeInformsDefault} />
        </div>
      </div>
    </div>
  );
};

export default FreeTariff;
